// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { CostCodeFragmentDoc } from '../../../../queries/fragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type AddScopeTemplateItemsQueryVariables = Types.Exact<{
  templateId: Types.Scalars['ID']['input'];
}>;


export type AddScopeTemplateItemsQuery = { __typename?: 'Query', items: Array<{ __typename?: 'Item', id: string, displayName: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string }, costCode: { __typename?: 'CostCode', id: string, number: string, name: string, displayName: string } }>, locations: Array<{ __typename?: 'Location', id: string, name: string, isWholeHouse: boolean }>, costTypes: Array<{ __typename?: 'CostTypeDetail', code: Types.CostType, name: string }>, itemTemplate: { __typename?: 'ItemTemplate', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string, shortName?: string | null | undefined, active: boolean, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean, isExteriorPalette: boolean, isSpecLevel: boolean }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined, globalOption: { __typename?: 'GlobalOption', id: string }, childOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, active: boolean, globalOption: { __typename?: 'GlobalOption', id: string } }> }> } | null | undefined } };

export type AddItemOptionFragment = { __typename?: 'ReadyPlanOption', id: string, displayName: string, shortName?: string | null | undefined, active: boolean, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean, isExteriorPalette: boolean, isSpecLevel: boolean }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined, globalOption: { __typename?: 'GlobalOption', id: string }, childOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, active: boolean, globalOption: { __typename?: 'GlobalOption', id: string } }> };

export type ScopeTemplateAddItemFragment = { __typename?: 'Item', id: string, displayName: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string }, costCode: { __typename?: 'CostCode', id: string, number: string, name: string, displayName: string } };

export const AddItemOptionFragmentDoc = gql`
    fragment AddItemOption on ReadyPlanOption {
  id
  displayName
  shortName
  active
  type {
    id
    isElevation
    isExteriorPalette
    isSpecLevel
  }
  location {
    id
    name
  }
  globalOption {
    id
  }
  childOptions {
    id
    name
    active
    globalOption {
      id
    }
  }
}
    `;
export const ScopeTemplateAddItemFragmentDoc = gql`
    fragment ScopeTemplateAddItem on Item {
  id
  displayName
  unitOfMeasure {
    id
  }
  costCode {
    ...CostCode
  }
}
    ${CostCodeFragmentDoc}`;
export const AddScopeTemplateItemsDocument = gql`
    query AddScopeTemplateItems($templateId: ID!) {
  items(filter: {status: [ACTIVE]}) {
    ...ScopeTemplateAddItem
  }
  locations {
    id
    name
    isWholeHouse
  }
  costTypes {
    code
    name
  }
  itemTemplate(id: $templateId) {
    id
    readyPlan {
      id
      options {
        ...AddItemOption
      }
    }
  }
}
    ${ScopeTemplateAddItemFragmentDoc}
${AddItemOptionFragmentDoc}`;

/**
 * __useAddScopeTemplateItemsQuery__
 *
 * To run a query within a React component, call `useAddScopeTemplateItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddScopeTemplateItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddScopeTemplateItemsQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useAddScopeTemplateItemsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AddScopeTemplateItemsQuery, AddScopeTemplateItemsQueryVariables> & ({ variables: AddScopeTemplateItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AddScopeTemplateItemsQuery, AddScopeTemplateItemsQueryVariables>(AddScopeTemplateItemsDocument, options);
      }
export function useAddScopeTemplateItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AddScopeTemplateItemsQuery, AddScopeTemplateItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AddScopeTemplateItemsQuery, AddScopeTemplateItemsQueryVariables>(AddScopeTemplateItemsDocument, options);
        }
// @ts-ignore
export function useAddScopeTemplateItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AddScopeTemplateItemsQuery, AddScopeTemplateItemsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddScopeTemplateItemsQuery, AddScopeTemplateItemsQueryVariables>;
export function useAddScopeTemplateItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddScopeTemplateItemsQuery, AddScopeTemplateItemsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddScopeTemplateItemsQuery | undefined, AddScopeTemplateItemsQueryVariables>;
export function useAddScopeTemplateItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddScopeTemplateItemsQuery, AddScopeTemplateItemsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AddScopeTemplateItemsQuery, AddScopeTemplateItemsQueryVariables>(AddScopeTemplateItemsDocument, options);
        }
export type AddScopeTemplateItemsQueryHookResult = ReturnType<typeof useAddScopeTemplateItemsQuery>;
export type AddScopeTemplateItemsLazyQueryHookResult = ReturnType<typeof useAddScopeTemplateItemsLazyQuery>;
export type AddScopeTemplateItemsSuspenseQueryHookResult = ReturnType<typeof useAddScopeTemplateItemsSuspenseQuery>;
export type AddScopeTemplateItemsQueryResult = Apollo.QueryResult<AddScopeTemplateItemsQuery, AddScopeTemplateItemsQueryVariables>;